import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import { sectionHref } from "./sections";

// El cierre del mes como un recorrido en orden. Antes eran dos botones dentro
// de "Reportes" ("Planilla de liquidación de gastos" y "Previsualizar
// planilla…") sin nada que dijera cuál iba primero.
const stepsFor = ({ base, isManager }) => [
  isManager && {
    key: "review",
    title: "Revisa los gastos del período",
    description: "Comprueba que estén cargados todos los gastos antes de preparar la planilla.",
    to: sectionHref("expenses"),
    actionLabel: "Ver gastos",
  },
  {
    key: "preview",
    title: "Previsualiza la planilla",
    description: "Revisa cuánto le corresponde pagar a cada propiedad antes de enviarla.",
    to: `${base}/form`,
    actionLabel: "Previsualizar planilla",
    primary: true,
  },
  {
    key: "send",
    title: "Descarga o envía la planilla",
    description:
      "Planilla de liquidación de gastos: descárgala en PDF o envíala por correo a los propietarios.",
    to: `${base}/reports`,
    actionLabel: "Ir a la planilla",
  },
];

const FinanceSettlement = ({ base, role }) => {
  const steps = stepsFor({ base, isManager: role === "manager" }).filter(Boolean);

  return (
    <>
      <p className="text-700 mb-3">
        El cierre de cada mes, paso a paso: revisa los gastos, previsualiza la planilla y
        compártela con los propietarios.
      </p>
      <Row>
        {steps.map((step, index) => (
          <Col key={step.key} lg={12 / steps.length} className="mb-3">
            <Card className={`h-100 ${step.primary ? "border border-primary" : ""}`}>
              <CardBody className="d-flex flex-column">
                <div className="d-flex align-items-center mb-3">
                  <span
                    className={`rounded-circle d-flex flex-center mr-2 font-weight-bold ${
                      step.primary ? "bg-primary text-white" : "bg-200 text-700"
                    }`}
                    style={{ width: 30, height: 30 }}
                  >
                    {index + 1}
                  </span>
                  <span className="fs--2 text-uppercase font-weight-semi-bold text-600">
                    Paso {index + 1}
                  </span>
                </div>
                <h5 className="mb-2">{step.title}</h5>
                <p className="fs--1 text-600">{step.description}</p>
                <div className="mt-auto">
                  <Button
                    tag={Link}
                    to={step.to}
                    color={step.primary ? "primary" : "falcon-default"}
                    size="sm"
                  >
                    {step.actionLabel}
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </>
  );
};

FinanceSettlement.propTypes = {
  base: PropTypes.string.isRequired,
  role: PropTypes.string,
};

export default FinanceSettlement;
